import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Category, CategoryColorKey } from './categoryColors';
import { Input } from '../../../components/ui/input';
import { Button } from '../../../components/ui/button';
import { SwatchGrid } from './SwatchGrid';

export interface CategoryFormProps {
    initialName: string;
    initialColor: CategoryColorKey | null;
    taken: Set<CategoryColorKey>;
    onSave: (next: Category) => void;
    onCancel: () => void;
}

export default function CategoryForm({
    initialName,
    initialColor,
    taken,
    onSave,
    onCancel,
}: CategoryFormProps) {
    const { t } = useTranslation();
    const [name, setName] = useState(initialName);
    const [color, setColor] = useState<CategoryColorKey | null>(initialColor);

    const canSave = name.trim().length > 0 && color !== null;

    return (
        <div className="flex flex-col gap-2 p-1">
            <Input
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder={t('folders.category.namePlaceholder')}
                maxLength={60}
                autoFocus
                className="h-8 text-xs"
                aria-label={t('folders.category.nameAria')}
            />
            <SwatchGrid selected={color} taken={taken} onSelect={setColor} />
            <div className="flex justify-end gap-2 pt-1">
                <Button
                    type="button"
                    variant="ghost"
                    size="sm"
                    onClick={onCancel}
                >
                    {t('folders.category.cancel')}
                </Button>
                <Button
                    type="button"
                    size="sm"
                    disabled={!canSave}
                    onClick={() => {
                        if (canSave && color) {
                            onSave({ name: name.trim(), color });
                        }
                    }}
                >
                    {t('folders.category.save')}
                </Button>
            </div>
        </div>
    );
}
